import { Ref, ref } from 'vue';

export default function useTabDynamicUnderline() {
    const targetWidth = ref<number>(0);
    const targetXPosition = ref<number>(0);
    const tabElementList: Ref<{el: HTMLElement}[]> = ref([]);

    const setUnderlineAnimation = (index) => {
        const isActiveTab = index < tabElementList.value.length && tabElementList.value[index].el?.classList.contains('tab--active');
        if (!isActiveTab) {
            targetXPosition.value = tabElementList.value[index].el.offsetLeft;
            targetWidth.value = tabElementList.value[index].el.clientWidth;
        }
    };
    const setDefaultUnderline = (index) => {
        const isActiveTab = index < tabElementList.value.length && tabElementList.value[index].el?.classList.contains('tab--active');
        if (isActiveTab) {
            targetXPosition.value = tabElementList.value[index].el.offsetLeft;
            targetWidth.value = tabElementList.value[index].el.clientWidth;
        }
    };

    const removeUnderline = () => {
        const activeTab = tabElementList.value.find((element) => element.el?.classList.contains('tab--active'));
        if (activeTab) {
            targetWidth.value = activeTab.el.clientWidth;
            targetXPosition.value = activeTab.el.offsetLeft;
        } else {
            targetWidth.value = 0;
        }
    };

    return {
        removeUnderline,
        setUnderlineAnimation,
        setDefaultUnderline,
        tabElementList,
        targetWidth,
        targetXPosition,
    };
}
